import { jsx as o } from "react/jsx-runtime";
const C = ({
  width: r,
  height: t,
  className: n
}) => /* @__PURE__ */ o(
  "svg",
  {
    className: n,
    fill: "none",
    height: t,
    viewBox: "0 0 16 16",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M5.66703 5.737C5.6698 5.30439 5.32164 4.9513 4.88903 4.948H1.77803C1.34543 4.9513 0.997261 5.30439 1.00002 5.737V14.211C0.997261 14.6436 1.34543 14.9967 1.77803 15H14.222C14.6546 14.9967 15.0028 14.6436 15 14.211V4.158C15.0028 3.72578 14.6552 3.37285 14.223 3.369H11.112C10.6794 3.3723 10.3313 3.72539 10.334 4.158V1.789C10.3368 1.35639 9.98864 1.0033 9.55603 1H6.44403C6.01182 1.00385 5.66426 1.35678 5.66703 1.789V5.737ZM5.66703 5.737L5.66702 15M10.333 15V4.15796",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      }
    )
  }
);
export {
  C as Content
};
